import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { routes } from "../Route/Routes";
import * as Yup from "yup";
import { useAuth } from "oidc-react";

export const d2Time = (date) => {
  return moment(date, "YYYY-MM-DDTHH:mm:ss").format("HH:mm");
};
export const dateFormat = (date) => {
  return moment(date, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD");
};

export const SELECTED_FORM_TIME = "09:00";

export const HourFormat = (hr) => {
  let size = 2;
  let s = "000000000" + hr;
  return s.substr(s.length - size) + ":00";
};
export const ShowSucess = (message) => {
  if (message === undefined) {
    return;
  }
  toast(`${message}`, {
    theme: "light",
    position: toast.POSITION.TOP_RIGHT,
  });
};
export const ShowError = (message) => {
  if (message === undefined) {
    return;
  }
  toast.error(`${message}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    style: {
      width: "auto",
      height: "auto",
    },
  });
};

export const extractApiError = (error) => {
  if(error?.response?.status === 404) return null;
  const resData = error?.response?.data;
  if(!resData) return "Something went wrong. Please try again.";

  if(typeof resData === 'string') return resData;

  if(typeof resData === 'object') {
    const parts = [
      resData?.title, resData?.Message, resData?.message,
      resData?.detail, resData?.error, resData?.description,
      resData?.errorMessage, resData?.msg, resData?.ExceptionMessage
    ].filter(Boolean);

    if(resData?.errors) {
      if(Array.isArray(resData.errors)) parts.push(...resData.errors.filter(Boolean));
      else if(typeof resData.errors === 'object')
        Object.values(resData.errors).flat().forEach(e => parts.push(e));
    }
    if(parts.length) return parts.join(' | ');
  }
  return "Something went wrong. Please try again.";
};

export const ShowWarning = (message) => {
  if (message === undefined) {
    return;
  }
  toast.warn(`${message}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // theme: "light",
  });
};

export const WeekColor = (startDate, EndDate, currentDate, paycode = "") => {
  let result = {};
  const week1StartDate = startDate;
  const week1EndDate = moment(startDate, "YYYY-MM-DD")
    .add(6, "d")
    .format("YYYY-MM-DD");
  const week2StartDate = moment(startDate, "YYYY-MM-DD")
    .add(7, "d")
    .format("YYYY-MM-DD");
  const week2EndDate = EndDate;
  if (["O/T1.5"].includes(paycode)) {
    return "#b1d4ff6b";
  }

  if (currentDate >= week1StartDate && currentDate <= week1EndDate) {
    return "#f6e5e5";
  } else if (currentDate >= week2StartDate && currentDate <= week2EndDate) {
    return "#d9ecd9";
  } else {
    return "#f6e5e5";
  }
};
export const HourMinFormat = (hrMin) => {
  let sec = hrMin.split(":");
  let size = 2;
  let s = "000000000" + sec[0];
  let s2 = "000000000" + sec[1];
  let hr = s.substr(s.length - size);
  let min = s2.substr(s2.length - size);
  return hr + ":" + min;
};

export const KeyGen = (length = 7) => {
  var result = "";
  var characters = `ABCDEFGHIJKLMNOPQRSTUV${moment(
    "YYMMDDHHmmss"
  )}WXYZabcdefghijklmnopqrstuvwxyz0123456789`;
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const KeyGenV2 = (length = 7) => {
  var result = "";
  var characters = `13121424432523532513121424432523532543232421312142443252353252334131214244325235325343242`;
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const RemoveSpaceKeyGen = (text) => {
  text = text.replace(" ", "");
  text = text.replace("/", "");
  text = text.replace(/[-]/g, "");
  text = text.replace(/[^\w-]+/g, "");
  return text;
};

export const timeSlotCheckInBeetween = (
  selectedDateFrom,
  elementFrom,
  elementTo
) => {
  const formate = "YYYY-MM-DD HH:mm";
  try {
    if (
      selectedDateFrom.length >= 16 &&
      elementFrom.length >= 16 &&
      elementTo.length >= 16
    ) {
      //from & to is proper date
      let startDate = moment(elementFrom, formate);

      // 12-07-2022 21:00
      let endDate = moment(elementTo, formate);
      let testDate = moment(selectedDateFrom, formate);

      let resultFrom = testDate.isBetween(startDate, endDate, "minute", false); // will return true
      if (resultFrom) {
        // _firstTimeSlotError = true;
        console.log(
          "SELECTED " +
          selectedDateFrom +
          " is between " +
          elementFrom +
          ", End : " +
          elementTo
        );
        return true;
      }
    }
    return false;
  } catch (err) {
    console.log("error SELECT " + err);
    return false;
  }
};

export const checkAddedTimeError1 = (listData, currentData1, callbackError) => {
  console.log("HEllo");
  let hasError = false;

  if (listData && listData.length > 0) {
    listData.forEach((currentData) => {
      let innerError = checkAddedTimeInner(listData, currentData);
      if (innerError) {
        hasError = true;
      }
    });
    callbackError(hasError);

    // const errorList = listData.filter((data) => {
    //   return data["ole1"] || data["ole2"];
    // });

    // console.log("errorList length" + errorList ? errorList.length : "0");

    return listData;
  }
};

export const checkAddedTimeInner = (listData, currentData) => {
  if (listData && listData.length > 0 && currentData) {
    let sf = currentData.date + " " + currentData.time_from;
    let st = currentData.date + " " + currentData.time_to;

    let sf1 = currentData.date + " " + currentData.time_from1;
    let st1 = currentData.date + " " + currentData.time_to1;

    let currentError1 = false;
    let currentError2 = false;

    listData.forEach((element) => {
      console.log("SELECTED ID " + element.id);

      //Check selected time slot's Form time is between any other row's range.

      if (
        element.jobtype === "REG" &&
        currentData.jobtype === "REG" &&
        element.date === currentData.date &&
        ((element.time_from && element.time_to) ||
          (element.time_from1 && element.time_to1))
      ) {
        //First time slot propery entered.
        let ef = element.date + " " + element.time_from;
        let et = `${element.date} ${element.time_to}`;

        let ef1 = element.date + " " + element.time_from1;
        let et1 = element.date + " " + element.time_to1;

        let elementError1 = false;
        let elementError2 = false;

        if (currentData.id !== element.id) {
          if (
            (sf.length > 11 && ef.length > 11 && sf === ef) ||
            (st.length > 11 && et.length > 11 && st === et) ||
            timeSlotCheckInBeetween(sf, ef, et) ||
            timeSlotCheckInBeetween(st, ef, et) ||
            timeSlotCheckInBeetween(ef, sf, st) ||
            timeSlotCheckInBeetween(et, sf, st)
          ) {
            elementError1 = true;
            currentError1 = true;
          }

          if (
            (sf.length > 11 && ef1.length > 11 && sf === ef1) ||
            (st.length > 11 && et1.length > 11 && st === et1) ||
            timeSlotCheckInBeetween(sf, ef1, et1) ||
            timeSlotCheckInBeetween(st, ef1, et1) ||
            timeSlotCheckInBeetween(ef1, sf, st) ||
            timeSlotCheckInBeetween(et1, sf, st)
          ) {
            elementError2 = true;
            currentError1 = true;
          }

          if (
            (sf1.length > 11 && ef.length > 11 && sf1 === ef) ||
            (st1.length > 11 && et.length > 11 && st1 === et) ||
            timeSlotCheckInBeetween(sf1, ef, et) ||
            timeSlotCheckInBeetween(st1, ef, et) ||
            timeSlotCheckInBeetween(ef, sf1, st1) ||
            timeSlotCheckInBeetween(et, sf1, st1)
          ) {
            elementError1 = true;
            currentError2 = true;
          }
          if (
            (sf1.length > 11 && ef1.length > 11 && sf1 === ef1) ||
            (st1.length > 11 && st1.length > 11 && st1 === et1) ||
            timeSlotCheckInBeetween(sf1, ef1, et1) ||
            timeSlotCheckInBeetween(st1, ef1, et1) ||
            timeSlotCheckInBeetween(ef1, sf1, st1) ||
            timeSlotCheckInBeetween(et1, sf1, st1)
          ) {
            elementError2 = true;
            currentError2 = true;
          }
          element["ole1"] = elementError1;
          element["ole2"] = elementError2;
          currentData["ole2"] = currentError2;
        } else {
          console.log("CHECK IN OWN TIME SLOT ");
        }
      }
    });

    if (currentData.jobtype === "REG") {
      if (
        (sf.length > 11 && sf1.length > 11 && sf === sf1) ||
        (st.length > 11 && st1.length > 11 && st === st1) ||
        timeSlotCheckInBeetween(sf, sf1, st1) ||
        timeSlotCheckInBeetween(st, sf1, st1) ||
        timeSlotCheckInBeetween(sf1, sf, st) ||
        timeSlotCheckInBeetween(st1, sf, st)
      ) {
        currentError1 = true;
        currentError2 = true;
      }
    }

    currentData["ole1"] = currentError1;
    currentData["ole2"] = currentError2;

    console.log("HEllo", listData.length, "AAA##", JSON.stringify(currentData));

    if (currentError1 || currentError2) {
      return true;
    }
    return false;

    // return listData;
  }
};
export const formatMoney = (number) => {
  number = parseFloat(number);
  return number.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

export const format2Decimal = (number) => {
  number = parseFloat(number);
  var rounded = Math.round((number + Number.EPSILON) * 100) / 100;
  return rounded;
};

export const getUserRole = (userData, check = false) => {
  if (!check && sessionStorage.getItem("currentRole")) {
    return sessionStorage.getItem("currentRole");
  }
  if (!userData) {
    console.warn(
      "getUserRole : pass value from   const { userData } = useAuth()  "
    );
  }
  if (userData && userData.profile && userData.profile.role) {
    return userData.profile.role;
  } else {
    return "";
  }
};

export const getUserId = (userData) => {
  if (!userData) {
    console.warn(
      "getUserRole : pass value from   const { userData } = useAuth()"
    );
  }
  if (userData && userData.profile && userData.profile.EmployeeID) {
    return userData.profile.EmployeeID;
  } else {
    return 0; // for test admin dashboard
  }
};
export const isAllowedURL = (patternURL, userData) => {
  const role = getUserRole(userData);
  const route = routes.find((d) => d.path.indexOf(patternURL) > -1);
  return (
    route && (route?.roles?.indexOf(role) > -1 || route?.roles === undefined)
  ); // !!matchPath(checkUrl,patternURL)
};
export const filterAllowedColumn = (
  userData,
  columns = [],
  recordidfield = "id"
) => {
  const role = getUserRole(userData);
  const employeeColumn = [
    "ssn",
    "firstname",
    "lastname",
    "id",
    "employeeid",
    "employeename",
  ];

  if (role === "user" || role === undefined) {
    return columns.filter((d) => {
      const fieldName = d.field.toLowerCase();

      if (fieldName === "employeename_lfm") {
        return false;
      }

      return (
        employeeColumn.indexOf(fieldName) < 0 ||
        fieldName === recordidfield.toLowerCase()
      );
    });
  } else {
    return columns;
  }
};
// export const filterAllowedColumn = (
//   userData,
//   columns = [],
//   recordidfield = "id"
// ) => {
//   const role = getUserRole(userData);
//   const employeeColumn = [
//     "ssn",
//     "firstname",
//     "lastname",
//     "id",
//     "employeeid",
//     "employeename",
//   ];
//   // debugger;
//   if (role === "user" || role === undefined) {
//     return columns.filter(
//       (d) =>
//         employeeColumn.indexOf(d.field.toLowerCase()) < 0 ||
//         d.field.toLowerCase() === recordidfield.toLowerCase()
//     );
//   } else {
//     return columns;
//   }
// };

export const timeToISODate = (time) => {
  const currentDate = new Date();
  const [hours, minutes, seconds] = (time || "").split(":").map(Number);
  currentDate.setHours(hours, minutes, seconds);
  return currentDate.toISOString();
};

export const getHMFromTime = (time_from1, time_to1) => {
  const startTime1 = moment(time_from1, "HH:mm");
  const endTime1 = moment(time_to1, "HH:mm");
  let duration1 = moment.duration(endTime1.diff(startTime1));
  if (duration1.asHours() < 0) {
    const endTime3 = moment(time_to1, "HH:mm").add(1, "day");
    duration1 = moment.duration(endTime3.diff(startTime1));
  }

  const hours1 = duration1._isValid ? parseInt(duration1.asHours()) : 0;
  const totalMin1 = duration1._isValid ? parseInt(duration1.asMinutes()) : 0;

  let hrCalc = HourMinFormat(`${Math.floor(totalMin1 / 60)}:${totalMin1 % 60}`);

  return {
    min: totalMin1,
    hr: hours1,
    hhmm: hrCalc,
  };
};

/** validationObject example */
/** {
  email: [
      { type: 'required', rules: ['Email is required'] },
      { type: 'min', rules: [3, 'Minimum length is 3 characters'], dataType: 'string' },
      { type: 'min', rules: [11, 'Number must be greater than 10'], dataType: 'number' },
      { type: 'email', rules: ['Invalid email address'] }
  ],
};  */
export const generateYupValidationSchema = (validationObject) => {
  const schema = {};

  for (const key in validationObject) {
    let validator;
    validationObject[key].forEach((validation) => {
      const { rules, type, dataType } = validation;
      validator = Yup[dataType || "string"]();
      validator = validator[type](...rules);
    });
    schema[key] = validator;
  }

  return Yup.object().shape(schema);
};

export const sortData = (data, sortBy, orderBy = null) => {
  if (data.length) {
    let sortedData = [...data].sort((a, b) => {
      let currentData = a[sortBy] ? a[sortBy] : "";
      let nextData = b[sortBy] ? b[sortBy] : "";
      // Use localeCompare to perform a case-insensitive alphabetical sort
      if (orderBy === "desc") {
        return nextData.localeCompare(currentData, undefined, {
          sensitivity: "base",
        });
      } else {
        return currentData.localeCompare(nextData, undefined, {
          sensitivity: "base",
        });
      }
    });

    return sortedData;
  } else {
    return [];
  }
};

export const formatDateMMDDYYYY = (date = new Date()) => {
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const year = String(date.getFullYear());

  return `${month}${day}${year}`;
};

export const isDataChange = (defaultObj, compObj) => {
  return JSON.stringify(defaultObj || "") == JSON.stringify(compObj || "");
};
export function orderByVendorCode(companyArray) {
  // Sorting function
  function compare(a, b) {
    const codeA = a.vendor_items[0].vendor_code.toUpperCase();
    const codeB = b.vendor_items[0].vendor_code.toUpperCase();

    if (codeA < codeB) {
      return -1;
    }
    if (codeA > codeB) {
      return 1;
    }
    // If vendor_code is the same, maintain the original order
    return 0;
  }

  // Sort the companyArray
  const sortedArray = companyArray.slice().sort(compare);
  return sortedArray;
}

export const removeKeyFromObjects = (data, keyToRemove) => {
  return data.map(({ [keyToRemove]: _, ...rest }) => rest);
};

export const getMonthDateRange = (monthIdentifier) => {
  let startDate;
  let endDate;

  switch (monthIdentifier) {
    case 'LastMonth':
      startDate = moment().subtract(1, 'months').startOf('month');
      endDate = moment().subtract(1, 'months').endOf('month');
      break;
    case 'ThisMonth':
      startDate = moment().startOf('month');
      endDate = moment().endOf('month');
      break;
    case 'NextMonth':
      startDate = moment().add(1, 'months').startOf('month');
      endDate = moment().add(1, 'months').endOf('month');
      break;
    default:
      throw new Error('Invalid month identifier. Use "LastMonth", "ThisMonth", or "NextMonth".');
  }

  return {
    startDate: startDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD')
  };
};

export function removeAfterString1(url, removeString) {
  const index = url.indexOf(removeString);
  let status = true
  let newUrl = url
  if (index !== -1) {
    newUrl = url.substring(0, index)
    status = false
  }

  return { newUrl, status };
}

export function removeAfterString(input, startToken) {
  let startIndex = input.indexOf(startToken);
  if (startIndex === -1) {
    return { status: false, newUrl: input };
  }

  let modifiedString = input.slice(0, startIndex);
  return { status: true, newUrl: modifiedString };
}

export const sortDisbled = (data) => {

  const sortedData = data.sort((a, b) => {
    const aContainsCoverage = a.Role?.includes("Coverage by");
    const bContainsCoverage = b.Role?.includes("Coverage by");

    if (aContainsCoverage && !bContainsCoverage) {
      return 1;
    } else if (!aContainsCoverage && bContainsCoverage) {
      return -1;
    } else {
      return 0;
    }
  });
  return sortedData

}



export const isJsonArrayString = (str) => {
  if (!str) {
    return []
  }
  try {
    return JSON.parse(str);
  } catch (e) {
    return [];
  }
}


export const isOlderThen = (date, year = 25) => {
  if (date) {
    const currentYear = moment().year();
    const defaultDate = moment(`10-01`, 'MM-DD').year(currentYear);
    if (moment(defaultDate, 'MM-DD-YYYY').diff(date, 'years') > year) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }

}

export const companyArrayDental = [
  {
    "vendor_name": "Net Care",
    "vendor_items": [
      {
        "vendor_code": "Dental 1500",
        "key": "dentalPlan",
        "classInfo": [
          {
            "value": "I",
            "className": "Class I",
            "label": "Subscriber Only",
            "key": "dentalDeductionClass",
            "amount": "21.89",
            "empRate": "8.77",
            "govRate": "13.12"

          },
          {
            "value": "II",
            "className": "Class II",
            "label": "Subscriber + Spouse/Domestic Partner",
            "key": "dentalDeductionClass",
            "amount": "47.07",
            "empRate": "28.38",
            "govRate": "18.69"
          },
          {
            "value": "III",
            "className": "Class III",
            "label": "Subscriber + Child(ren)",
            "key": "dentalDeductionClass",
            "amount": "38.31",
            "empRate": "22.78",
            "govRate": "15.53"
          },
          {
            "value": "IV",
            "className": "Class IV",
            "label": "Subscriber + Spouse/Dom. Partner & Child(ren)",
            "key": "dentalDeductionClass",
            "amount": "62.40",
            "empRate": "37.29",
            "govRate": "25.11"
          }
        ]
      }
    ]
  }
]


export const companyArray = [
  {
    "vendor_name": "Select Care",
    "vendor_items": [
      {
        "vendor_code": "HSA 2000",
        "key": "healthPlan",
        "classInfo": [
          {
            "value": "I",
            "className": "Class I",
            "label": "Subscriber Only",
            "key": "healthDeductionClass",
            "amount": "186.67",
            "empRate": "2.04",
            "govRate": "184.63"
          },
          {
            "value": "II",
            "className": "Class II",
            "label": "Subscriber + Spouse/Domestic Partner",
            "key": "healthDeductionClass",
            "amount": "364.67",
            "empRate": "45.08",
            "govRate": "319.59"
          },
          {
            "value": "III",
            "className": "Class III",
            "label": "Subscriber + Child(ren)",
            "key": "healthDeductionClass",
            "amount": "302.37",
            "empRate": "36.21",
            "govRate": "266.16"
          },
          {
            "value": "IV",
            "className": "Class IV",
            "label": "Subscriber + Spouse/Dom. Partner & Child(ren)",
            "key": "healthDeductionClass",
            "amount": "489.26",
            "empRate": "58.83",
            "govRate": "430.43"
          }
        ]
      }

    ]
  },
  {
    "vendor_name": "Select Care",
    "vendor_items": [
      {
        "vendor_code": "PPO 1500",
        "key": "healthPlan",

        "classInfo": [
          {
            "value": "I",
            "className": "Class I",
            "label": "Subscriber Only",
            "key": "healthDeductionClass",
            "amount": "406.24",
            "empRate": "77.36",
            "govRate": "328.88"
          },
          {
            "value": "II",
            "className": "Class II",
            "label": "Subscriber + Spouse/Domestic Partner",
            "key": "healthDeductionClass",
            "amount": "803.81",
            "empRate": "193.51",
            "govRate": "610.30"
          },
          {
            "value": "III",
            "className": "Class III",
            "label": "Subscriber + Child(ren)",
            "key": "healthDeductionClass",
            "amount": "664.66",
            "empRate": "145.71",
            "govRate": "518.95"
          },
          {
            "value": "IV",
            "className": "Class IV",
            "label": "Subscriber + Spouse/Dom. Partner & Child(ren)",
            "key": "healthDeductionClass",
            "amount": "1,082.11",
            "empRate": "239.13",
            "govRate": "842.98"
          }
        ]
      }

    ]
  }
]

export const RetireeHealthCompanyArray = [
  {
    "vendor_name": "Select Care",
    "vendor_items": [
      {
        "vendor_code": "HSA 2000",
        "key": "healthPlan",
        "classInfo": [
          {
            "value": "I",
            "className": "Class I",
            "label": "Subscriber Only",
            "key": "healthDeductionClass",
            "amount": "491.47",
            "empRate": "2.21",
            "govRate": "491.47"
          },
          {
            "value": "II",
            "className": "Class II",
            "label": "Subscriber + Spouse/Domestic Partner",
            "key": "healthDeductionClass",
            "amount": "973.54",
            "empRate": "48.84",
            "govRate": "924.70"
          },
          {
            "value": "III",
            "className": "Class III",
            "label": "Subscriber + Child(ren)",
            "key": "healthDeductionClass",
            "amount": "616.81",
            "empRate": "39.23",
            "govRate": "577.58"
          },
          {
            "value": "IV",
            "className": "Class IV",
            "label": "Subscriber + Spouse/Dom. Partner & Child(ren)",
            "key": "healthDeductionClass",
            "amount": "1,108.52",
            "empRate": "63.73",
            "govRate": "1,044.79"
          }
        ]
      }

    ]
  },
  {
    "vendor_name": "Select Care",
    "vendor_items": [
      {
        "vendor_code": "PPO 1500",
        "key": "healthPlan",

        "classInfo": [
          {
            "value": "I",
            "className": "Class I",
            "label": "Subscriber Only",
            "key": "healthDeductionClass",
            "amount": "1,086.15",
            "empRate": "83.81",
            "govRate": "1,002.34"
          },
          {
            "value": "II",
            "className": "Class II",
            "label": "Subscriber + Spouse/Domestic Partner",
            "key": "healthDeductionClass",
            "amount": "2,162.90",
            "empRate": "209.64",
            "govRate": "1,953.26"
          },
          {
            "value": "III",
            "className": "Class III",
            "label": "Subscriber + Child(ren)",
            "key": "healthDeductionClass",
            "amount": "1,366.10",
            "empRate": "157.85",
            "govRate": "1,208.25"
          },
          {
            "value": "IV",
            "className": "Class IV",
            "label": "Subscriber + Spouse/Dom. Partner & Child(ren)",
            "key": "healthDeductionClass",
            "amount": "2,464.39",
            "empRate": "259.06",
            "govRate": "2,205.33"
          }
        ]
      }
    ]
  }
]

export const RetireeDentalCompanyArray = [
  {
    "vendor_name": "Net Care",
    "vendor_items": [
      {
        "vendor_code": "Dental 1500",
        "key": "dentalPlan",
        "classInfo": [
          {
            "value": "I",
            "className": "Class I",
            "label": "Subscriber Only",
            "key": "dentalDeductionClass",
            "amount": "23.72",
            "empRate": "9.05",
            "govRate": "14.67"

          },
          {
            "value": "II",
            "className": "Class II",
            "label": "Subscriber + Spouse/Domestic Partner",
            "key": "dentalDeductionClass",
            "amount": "50.99",
            "empRate": "30.14",
            "govRate": "20.85"
          },
          {
            "value": "III",
            "className": "Class III",
            "label": "Subscriber + Child(ren)",
            "key": "dentalDeductionClass",
            "amount": "41.51",
            "empRate": "24.19",
            "govRate": "17.32"
          },
          {
            "value": "IV",
            "className": "Class IV",
            "label": "Subscriber + Spouse/Dom. Partner & Child(ren)",
            "key": "dentalDeductionClass",
            "amount": "67.60",
            "empRate": "39.59",
            "govRate": "28.01"
          }
        ]
      }
    ]
  }
]

export const getAgeGroup = (birthDate) => {
  console.log("asdaasdasd", birthDate);
  let Date = moment()
  const todayDate = moment(); // Fixed date as per your request
  const birthDateObj = moment(birthDate);
  const age = todayDate.diff(birthDateObj, 'years');
  console.log("asdaasdasd", age, birthDate);


  if (age <= 17) {
    return 1;
  } else if (age >= 18 && age <= 39) {
    return 2;
  } else {
    return 3;
  }
};

export const isJsonParse = (data) => {
  try {
    if (data) {
      return JSON.parse(data)
    }
    else {
      return []
    }
  } catch (error) {
    return []
  }
};



export const EmployeesStatus = (data)=>{
  if(data==="R"){
    return "Retiree"
  }else if(data==="A"){
    return "Active"
  }else if(data==="RSP"){
    return "RSP"
  }else{
    return "Active"
  }
}